'use client';

import { useAppDispatch, useAppSelector } from '@/app/lib/store/hooks';
import { usePathname, useRouter } from 'next/navigation';
import { closeDrawer } from '@/app/lib/store/drawer-slice';
import { clearUser } from '@/app/lib/store/user-slice';
import { APP_URLS } from '@/app/lib/constants/app-urls';
import SidebarNavigation from './sidebar-navigation';
import { clearSearchParams } from '@/app/lib/store/search-params-slice';
import { ENDPOINTS } from '@/app/lib/constants/endpoints';

export default function SidebarNavigationContainer() {
  const branches = useAppSelector(state => state.navigation.branches);
  const pathname = usePathname();
  const router = useRouter();
  const dispatch = useAppDispatch();
  const user = useAppSelector(state => state.user.data);

  const handleBeforeNavigation = () => {
    dispatch(clearSearchParams());
    setTimeout(() => dispatch(closeDrawer()), 500);
  };

  const handleLogin = () => {
    router.push('/auth');
    setTimeout(() => dispatch(closeDrawer()), 500);
  };

  const handleSignUp = () => {
    router.push(APP_URLS.signUpChoosePlanUrl);
    setTimeout(() => dispatch(closeDrawer()), 500);
  };

  const handleLogout = async () => {
    const endpoint = new URL(
      ENDPOINTS.logout,
      process.env.NEXT_PUBLIC_BASE_URL
    ).toString();
    await fetch(endpoint, { method: 'POST' });
    dispatch(clearUser());
    const protectedRoutes = ['premium', 'myaccount'];
    const onProtectedRoute = pathname
      .split('/')
      .some(segment => protectedRoutes.includes(segment));
    if (onProtectedRoute) router.push('/');
    setTimeout(() => dispatch(closeDrawer()), 500);
  };

  return (
    <SidebarNavigation
      branches={branches}
      pathname={pathname}
      user={user}
      onClick={handleBeforeNavigation}
      onLogin={handleLogin}
      onSignUp={handleSignUp}
      onLogout={handleLogout}
    />
  );
}
